import {
  GET_PTO_REPORT,
  GET_PTO_REPORT_ERROR,
  GET_PTO_REPORT_SUCCESS,
} from './Pto.actions';

const initialState = {
  data: [],
  loading: false,
  error: undefined,
};

/**
 * The Pto Reducer.
 */
const ptoReducer = (state = initialState, { payload, type }) => {
  switch (type) {
    case GET_PTO_REPORT: {
      return { ...state, loading: true, error: undefined }; // Set loading to true
    }
    case GET_PTO_REPORT_ERROR: {
      return { ...state, loading: false, error: payload.error }; // Set error and loading to false
    }
    case GET_PTO_REPORT_SUCCESS: {
      return {
        ...state,
        loading: false,
        error: undefined,
        data: payload.data, // Save the data to the state
      };
    }
    default: {
      return state; // Default case to return the unchanged state
    }
  }
};

export default ptoReducer;
